const listingHighlights = {
  displayField: 'header',
  name: 'Listing Highlights',
  description: 'Contentful new schema template',
  fields: [
    {
      id: 'header',
      name: 'Header Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'tabs',
      name: 'Tabs',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'listingHighlightsTab' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  sys: {
    id: 'listingHighlights',
    version: 14,
    updatedAt: '2023-03-06T19:13:11.103Z'
  }
};
export default listingHighlights;